module.exports = __webpack_public_path__ + "img/egas-logo-color.ec22a3be.png";